import { render, staticRenderFns } from "./ReportDocumentationDialog.vue?vue&type=template&id=1a451121&"
import script from "./ReportDocumentationDialog.vue?vue&type=script&lang=js&"
export * from "./ReportDocumentationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SPRAYER_MANAGER/SPRAYER_MANAGER_SITO/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex})
